
export const apiDomain              = 'https://alpha.gixcore.com/api/';
export const loginUrl               = apiDomain + 'oath/token';

export const SERVER_PATH            = 'https://alpha.gixcore.com/';

export const addItemUrl             = apiDomain + 'additem';

export const deleteItemUrl          = apiDomain + 'single';

export const AMAZON_LINK            = 'https://amazon.com/dp/';
export const AMAZON_REF             = '/ref=nosim?tag=gixcore-20'
